import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from '@webs/components-library/theming';


@customElement('webs-accordion-item')
export class AccordionItem extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`

    .m-accordion__wrapper { border-bottom: 1px solid #E5641F; }
    .m-accordion__wrapper.is-first-accordion { border-top: 1px solid #E5641F; }
    .m-accordion__wrapper .accordion-title { align-items: stretch; display: inline-flex; padding: 1.3rem 0; width: 100%; text-decoration: none; }

    .m-accordion__wrapper .trigger {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        height: 26px;
        justify-content: center;
        margin-left: 1.2rem;
        margin-right: .4rem;
        line-height: 1.3;
        width: 16px;
      }
    .m-accordion__wrapper .trigger::before,
    .m-accordion__wrapper .trigger::after
      { background: var(--color-base);
        content: '';
        display: block;
        height: 2px;
      }

    .m-accordion__wrapper .trigger::before { width: 16px; }

    .m-accordion__wrapper .trigger::after { left: 50%; margin: -1px -8px 0px; top: 50%; transform: translate(-50%, -50%) rotate(90deg); width: 100%; width: 16px; }

    .m-accordion__wrapper.open .trigger {
        height: 26px;
        position: relative;
        width: 16px;
      }

    .m-accordion__wrapper.open .trigger::before,
    .m-accordion__wrapper.open .trigger::after {
        left: 50%;
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
      }

    .m-accordion__wrapper .accordion-title h5 { flex: 1; margin-bottom: 0; }
    .m-accordion__wrapper .accordion-title:hover { text-decoration: none; }

    .m-accordion__wrapper .content { display: none; padding: 0.8rem 0 4rem; }
    .m-accordion__wrapper .rich-text-container { padding-right: 3rem; }
    .m-accordion__wrapper .rich-text-container ::slotted(img) { max-width: 100%; }
    .m-accordion__wrapper.open .content { display: block; }
    .m-accordion__wrapper.open .accordion-title { padding-bottom: 0; }

    @media only screen and (min-width: 768px) {
      .m-accordion__wrapper .accordion-title.is-first { padding-top: 0; }
      .m-accordion__wrapper.is-first-accordion { border-top: none; }
      .m-accordion__wrapper.open { border-bottom: none; }
    }

    @media only screen and (min-width: 992px){
    .m-accordion__wrapper .trigger { height: 32px; }
    .m-accordion__wrapper.open .trigger { height: 32px; }
      .m-accordion__wrapper .accordion-title { padding: 1.5rem 0; }
      .m-accordion__wrapper .accordion-title:hover h5 { color: var(--color-primary); }
      .m-accordion__wrapper .trigger { margin-left: 2.4rem; margin-right: 1.6rem; }
      .m-accordion__wrapper .content { padding: 1rem 0 2.5rem; }
      .m-accordion__wrapper .rich-text-container { padding-right: 3.6rem; }
     }
    `
  ];

  @property()
  title: string;

  @property({attribute: 'open', type: Boolean})
  isOpen = false;

  @property({attribute: 'first', type: Boolean})
  isFirst = false;

  @property({attribute: 'first-accordion', type: Boolean})
  isFirstAccordion = false;

  protected render(): unknown {
    return html`
      <div class="m-accordion__wrapper ${this.isOpen ? 'open' : ''} ${this.isFirstAccordion ? 'is-first-accordion' : ''}">
        <a class="accordion-title ${this.isFirst ? 'is-first' : ''}" href="javascript:;">
          <h5>${this.title}</h5>
          <span class="trigger"></span>
        </a>
        <div class="content hidden" data-accordion-content>
          <div class="rich-text-container"><slot></slot></div>
        </div>
      </div>
    `
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    document.addEventListener('DOMContentLoaded', evt => {
      const items = this.shadowRoot.querySelector('slot').assignedElements();
      if (items.length > 0) {
        this.shadowRoot.querySelector('.content').classList.remove('hidden');
        for (let i = 0; i < items.length; i++){
          const image = items[i].querySelector<HTMLImageElement>('p > img');
          if(image) {
            image.style.maxWidth = '100%';
          }
        }
      }
    });
  }
}
